"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("./core");
var client_lib_js_player_addons_common_player_1 = require("@sky-uk-ott/client-lib-js-player-addons-common-player");
var PlayerFramework = (function () {
    function PlayerFramework() {
    }
    PlayerFramework.registerDeviceFactory = function (deviceFactory) {
        core_1.Core.registerDeviceFactory(deviceFactory);
    };
    Object.defineProperty(PlayerFramework, "player", {
        get: function () {
            return core_1.Core.getDevice().player;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlayerFramework, "deviceInfo", {
        get: function () {
            return core_1.Core.getDevice().deviceInfo;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlayerFramework, "storage", {
        get: function () {
            return core_1.Core.getDevice().storage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlayerFramework, "externalApps", {
        get: function () {
            return core_1.Core.getDevice().externalApps;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlayerFramework, "externalAppsLauncher", {
        get: function () {
            return core_1.Core.getDevice().externalAppsLauncher;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlayerFramework, "input", {
        get: function () {
            return core_1.Core.getDevice().input;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlayerFramework, "capabilities", {
        get: function () {
            return core_1.Core.getDevice().capabilities;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlayerFramework, "lifecycle", {
        get: function () {
            return core_1.Core.getDevice().lifecycle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlayerFramework, "networkStatus", {
        get: function () {
            return core_1.Core.getDevice().networkStatus;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlayerFramework, "containerUpdater", {
        get: function () {
            return core_1.Core.getDevice().containerUpdater;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlayerFramework, "parentalPin", {
        get: function () {
            return core_1.Core.getDevice().parentalPin;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlayerFramework, "deeplink", {
        get: function () {
            return core_1.Core.getDevice().deeplink;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlayerFramework, "downloads", {
        get: function () {
            return core_1.Core.getDevice().downloads;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlayerFramework, "network", {
        get: function () {
            return core_1.Core.getDevice().network || new client_lib_js_player_addons_common_player_1.VanillaNetwork();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlayerFramework, "videoOutput", {
        get: function () {
            return core_1.Core.getDevice().videoOutput;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlayerFramework, "deviceSpecific", {
        get: function () {
            var deviceSpecificApi = core_1.Core.getDevice().deviceSpecific;
            return deviceSpecificApi ? deviceSpecificApi : {};
        },
        enumerable: true,
        configurable: true
    });
    PlayerFramework.initialise = function (addons) {
        if (addons === void 0) { addons = []; }
        return core_1.Core.initialise(addons);
    };
    PlayerFramework.getCurrentDeviceType = function () {
        throw new Error('getCurrentDeviceType() is deprecated!');
    };
    PlayerFramework.registerDeviceFactories = function (devicesFactories) {
        throw new Error('registerDeviceFactories() is deprecated. Please use registerDeviceFactory()');
    };
    return PlayerFramework;
}());
exports.PlayerFramework = PlayerFramework;
